/* ============================================================================
   roon-outbound.js — outbound-click beacon (2026-08-29)
   ============================================================================
   Logs every click on a link that LEAVES roonbody.com (Amazon, The Green
   Jungle Beauty Shop, All For American, Faire, social, …) to
   links.roonbody.com/api/outbound, which stores one tiny blob per click.
   Powers the weekly site report's "partner referrals" section
   (~/roon/weekly-site-report/). No cookies, no PII — just the destination
   host, the page the click happened on, and the nearest section id.
   Loaded sitewide from layout/theme.liquid (defer). ROON FIXES marker:
   see ROON-CUSTOMIZATIONS.md → "outbound beacon".
   ========================================================================= */
(function () {
  var ENDPOINT = 'https://links.roonbody.com/api/outbound';
  // Hosts that are NOT outbound: our own storefront + checkout plumbing.
  var INTERNAL = /(^|\.)roonbody\.com$|(^|\.)myshopify\.com$|(^|\.)shopify\.com$|(^|\.)shop\.app$/i;

  function track(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    if (e.type === 'auxclick' && e.button !== 1) return; // middle-click only
    var href = a.href || '';
    if (!/^https?:/i.test(href)) return;
    var host;
    try { host = new URL(href).hostname.toLowerCase(); } catch (err) { return; }
    if (!host || host === location.hostname.toLowerCase() || INTERNAL.test(host)) return;

    var sec = a.closest('section[id], [data-section-id], [id^="shopify-section"]');
    var payload = JSON.stringify({
      h: host,
      u: href.slice(0, 400),
      p: location.pathname,
      s: sec ? (sec.id || sec.getAttribute('data-section-id') || '') : ''
    });
    try {
      if (navigator.sendBeacon) navigator.sendBeacon(ENDPOINT, payload);
      else fetch(ENDPOINT, { method: 'POST', body: payload, keepalive: true, mode: 'no-cors' });
    } catch (err) { /* never interfere with the click */ }

    /* Mirror the same signal into the third-party tools already on the page,
       so their reporting agrees with ours. Distinct custom event names are
       used on purpose: GA4's enhanced measurement may also auto-log outbound
       "click" events, and we must not double-count those. All guarded — if a
       tool is absent (consent withheld, script blocked) we silently skip it. */
    var dims = { link_domain: host, link_url: href.slice(0, 200), page_path: location.pathname };
    try { if (typeof window.gtag === 'function') window.gtag('event', 'outbound_click', dims); } catch (err) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', 'OutboundClick', { destination: host, page: location.pathname }); } catch (err) {}
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('set', 'outbound_host', host);
        window.clarity('event', 'outbound-click');
      }
    } catch (err) {}
  }

  document.addEventListener('click', track, true);
  document.addEventListener('auxclick', track, true);
})();
